import React from 'react';
import { Card } from '@/components/ui';

interface ComingSoonViewProps {
  title?: string;
  subtitle?: string;
}

const ComingSoonView: React.FC<ComingSoonViewProps> = ({
  title = 'Coming Soon',
  subtitle = 'This feature is not yet implemented.'
}) => (
  // flex-1 + min-h-0 fills whatever height the reporting content pane actually has, instead of a
  // 60vh guess - see DefaultReportsView.tsx for why that mattered on a phone.
  <div className="tw-flex tw-flex-1 tw-min-h-0 tw-justify-center tw-items-center">
    <Card>
      <Card.Body>
        <div className="tw-text-center tw-py-5">
          <i className="bi bi-gear-wide-connected tw-text-6xl tw-font-light tw-text-content-muted"></i>
          <h5 className="tw-mt-3 tw-text-content-muted">{title}</h5>
          <p className="tw-text-content-muted">{subtitle}</p>
        </div>
      </Card.Body>
    </Card>
  </div>
);

export default ComingSoonView; 